(async () => {
 'use strict';
 if (location.hash === '#subscription-help') return;
 if ((location.pathname !== '/pages/mobile-funnel' && location.pathname !== '/assets/funnel-review.html') || location.hash.startsWith('#manage=')) return;
 const root = document.getElementById('fs-mobile-funnel');
 if (!root) return;
 const base = 'https://checkout.futureselfrx.ai/integrations/shopify-genhealth/mobile-funnel';
 const catalog=await (window.fsCatalogReady || Promise.resolve(null));
 const product=window.fsCatalogProduct;
 const storageKey='fs-nmi-checkout'+(product?':'+product:'');
 const quote=()=>config?.plans?.[plan];
 const planId=()=>quote()?.plan_id || plan;
 const dollars=n=>'$'+(n/100).toFixed(n%100?2:0);
 const billingTerms=()=>plan==='monthly'?'I authorize '+dollars(quote().initial_cents)+' today and '+dollars(quote().renewal_cents)+' each month starting one month from today until I cancel. Payment does not guarantee a prescription.':'I authorize a one-time payment of '+dollars(quote().initial_cents)+'. This package does not renew automatically. Payment does not guarantee a prescription.';
 let config=catalog, plan = 'monthly', session, busy = false, configured = false, requestId;
 let tokenizing=false, tokenTimer=null, paymentGeneration=0;
 let loadingFields=false, configuredPlan=null, sdkPromise=null, tokenInFlight=false;
 let checkoutStep = 0, pendingWallet = null, walletOptions = null, expressLocked = false, expressSubmitting = false;
 const stepCopy = [
  ['KEEP YOUR ORDER CONNECTED','Where should we send your order updates?','Your details connect your order, medical intake, and care updates.'],
  ['DELIVERY DETAILS','Where should we send your order?','Enter your delivery address. Medication ships only if prescribed.'],
  ['REVIEW & PAY','Your next step starts here.','One final step. Choose how you’d like to pay.']
 ];
 function showCheckoutStep(index, focus = true) {
  checkoutStep = index;
  if(index===2 && config && !session) initializePayment();
  root.querySelector('.fs-checkout').dataset.checkoutStage=String(index);
  document.getElementById('fs-step-number').textContent=(index+3)+' / 5';
  document.getElementById("fs-express").hidden = index !== 2 || !!session;
  root.querySelectorAll('[data-checkout-panel]').forEach(el => {el.hidden = Number(el.dataset.checkoutPanel) !== index;});
  root.querySelectorAll('.fs-checkout-progress li').forEach((el,i) => {if(i===index) el.setAttribute('aria-current','step'); else el.removeAttribute('aria-current');});
  ['fs-checkout-eyebrow','fs-checkout-heading','fs-checkout-intro'].forEach((id,i) => {document.getElementById(id).textContent = stepCopy[index][i];});
  const form = document.getElementById('fs-contact-form');
  document.getElementById('fs-delivery-summary').textContent = [form.elements.first_name.value,form.elements.last_name.value].filter(Boolean).join(' ') + ' · ' + [form.elements.address1.value,form.elements.city.value,form.elements.state.value,form.elements.zip.value].filter(Boolean).join(', ');
  if (focus) {window.scrollTo({top:0,behavior:'instant'});document.getElementById('fs-checkout-heading').focus({preventScroll:true});}
 }
 root.addEventListener('click',event => {
  const next=event.target.closest('[data-checkout-next]'), back=event.target.closest('[data-checkout-back]');
  const mainBack=event.target.closest('[data-show="isStep3"] [data-action="back"]');
  if (!next && !back && !(mainBack && checkoutStep > 0 && !mainBack.textContent.includes('Change'))) return;
  event.preventDefault();event.stopImmediatePropagation();
  if (busy || session || expressLocked) return;
  if (next) {
   const inputs=root.querySelectorAll('[data-checkout-panel="'+checkoutStep+'"] input');
   for (const input of inputs) {if (!input.reportValidity()) return;}
   const state=document.getElementById('fs-contact-form').elements.state;state.value=state.value.trim().toUpperCase();
   showCheckoutStep(Math.min(2,checkoutStep+1));
  } else showCheckoutStep(Math.max(0,checkoutStep-1));
 },true);
 document.getElementById('fs-contact-form').addEventListener('keydown',event => {
  if(event.key==='Enter' && event.target.tagName==='INPUT') {event.preventDefault();root.querySelector('[data-checkout-panel="'+checkoutStep+'"] [data-checkout-next]')?.click();}
 });
 showCheckoutStep(0,false);
 const message = text => { document.getElementById('fs-payment-status').textContent = text; };
 async function api(path, body) {
  const response = await fetch(base + path, {method: body ? 'POST' : 'GET',headers: body ? {'Content-Type':'application/json'} : {}, body: body ? JSON.stringify(body) : undefined});
  const data = await response.json();
  if (!response.ok) throw new Error(typeof data.detail === 'string' ? data.detail : 'Checkout is unavailable. Please try again later.');
  return data;
 }
 function syncWalletAvailability(){
  const buttons=document.getElementById('fs-wallet-buttons');const disabled=!configured || configuredPlan!==plan || !document.getElementById('fs-billing-consent').checked || busy || !!session;buttons.inert=disabled;buttons.style.opacity=disabled?'.5':'1';
 }
 function locked(value) {
  busy = value;syncWalletAvailability();
  root.querySelectorAll('[data-checkout-back],[data-checkout-next],[data-action="back"],[data-action="chooseMonthly"],[data-action="chooseBundle"],[data-action="restart"]').forEach(el => {el.disabled = value || !!session || expressLocked || (!!pendingWallet && el.hasAttribute("data-action"));});
  document.getElementById('fs-nmi-submit').disabled = value;
 }
 function fields() {
  const form = document.getElementById('fs-contact-form');
  for (const input of form.querySelectorAll('input')) {
   if (!input.checkValidity()) {showCheckoutStep(Number(input.closest('[data-checkout-panel]').dataset.checkoutPanel));input.reportValidity();return null;}
  }
  if (!document.getElementById('fs-billing-consent').checked) {message('Please accept the billing terms before continuing.');document.getElementById('fs-billing-consent').focus(); return null;}
  return Object.fromEntries(new FormData(form));
 }
 function continueToIntake(data) {
  const link=document.getElementById('fs-intake-link');
  if(data.status !== 'paid' || !data.intake_url || link.hidden) return;
  showCheckoutStep(2,false);
  link.textContent='Continue to medical intake →';
  link.style.cssText='display:block;margin:20px 0;padding:16px;background:#193b30;color:#fff;border-radius:12px;text-align:center;text-decoration:none;font-size:17px;min-height:52px';
  document.getElementById('fs-nmi-submit').hidden=true;
  document.getElementById('fs-checkout-heading').textContent="Payment received. Let's complete your intake.";
  document.getElementById('fs-checkout-intro').textContent='Next: confirm your details, answer the medical questions, and sign your care consent.';
  link.focus();
  if(data.subscription_status !== 'review' && !link.dataset.continuing) {
   link.dataset.continuing='true';
   setTimeout(()=>location.replace(link.href),1200);
  }
 }
 async function showStatus(data) {
  if (data.status === 'ready') {configuredPlan=null; sessionStorage.removeItem(storageKey); session=null; locked(false); initializePayment(); return true; }
  if (data.intake_url) {
   const u = new URL(data.intake_url);
   if (u.origin !== 'https://checkout.futureselfrx.ai' || u.pathname !== '/integrations/shopify-genhealth/intake') throw new Error('Invalid intake destination');
   document.getElementById('fs-intake-link').href = u.href;
   document.getElementById('fs-intake-link').hidden = false;
   document.getElementById('fs-card-fields').hidden=true;
  }
  if (data.status === 'paid') {
   continueToIntake(data);
   message(data.message || (data.intake_url ? 'Payment received. Continue to your medical intake.' : 'Payment received. Preparing your intake link. You will also receive an email.'));
   if (plan === 'monthly' && data.subscription_status === 'active') document.getElementById('fs-cancel-renewals').hidden = false;
   return !!data.intake_url;
  }
  if (data.status === 'declined') {message(data.message);const retry=document.createElement('button');retry.type='button';retry.textContent='Start a new checkout';retry.addEventListener('click',()=>{sessionStorage.removeItem(storageKey);location.reload();});document.getElementById('fs-payment-status').appendChild(retry);return true;}
  message(data.message || 'Confirming your payment. Please do not pay again.');return false;
 }
 async function poll() {
  for (let i=0;i<20;i++) {
   try { if (await showStatus(await api('/status',{session_token:session.session_token}))) return; }
   catch (_) {message('Still confirming your payment. Do not pay again. Contact support if this persists.');}
   await new Promise(resolve => setTimeout(resolve,3000));
  }
  message('Payment confirmation is still pending. Do not pay again. Contact support@futureselfrx.com.');
 }
 async function submitToken(result) {
  try {
   const data = await api('/charge',{session_token:session.session_token,payment_token:result.token});
   if (!await showStatus(data)) await poll();
  } catch (_) {message('Payment confirmation was interrupted. Do not pay again; checking its status.');await poll();}
 }
 function expressMessage(text) {document.getElementById('fs-express-status').textContent=text;}
 function loadSDK(options) {
  if(!sdkPromise) sdkPromise=new Promise((resolve,reject)=>{
   const script=document.createElement('script');script.src=options.script_url;
   script.setAttribute('data-tokenization-key',options.public_key);
   script.setAttribute('data-variant','inline');
   const timer=setTimeout(()=>{sdkPromise=null;script.remove();reject(new Error('Payment fields could not load. Please retry.'));},15000);
   script.onload=()=>{clearTimeout(timer);resolve();};
   script.onerror=()=>{clearTimeout(timer);sdkPromise=null;script.remove();reject(new Error('Payment fields could not load. Please retry.'));};
   document.head.appendChild(script);
  });
  return sdkPromise;
 }
 async function initializePayment() {
  if(!config?.enabled || session || loadingFields || configuredPlan===plan) return;
  loadingFields=true;configured=false;syncWalletAvailability();
  const generation=++paymentGeneration;
  const requestedPlan=plan;
  const card=document.getElementById('fs-card-fields');card.hidden=false;
  document.getElementById('fs-express').hidden=false;
  document.getElementById('fs-nmi-submit').disabled=true;
  document.getElementById('fs-nmi-submit').textContent='Pay '+(quote()?dollars(quote().initial_cents):(plan==='bundle'?'$299':'$79'))+' now';
  message('Loading secure payment fields…');
  try {
   const options=await api('/wallet-options',{plan:config.plans[requestedPlan].plan_id || requestedPlan});
   await loadSDK(options);
   if(generation!==paymentGeneration)return;
   if(requestedPlan!==plan || checkoutStep!==2){loadingFields=false;return;}
   walletOptions=options;
    const monthly=plan==='monthly';
    const walletFields={
     ccnumber:{selector:'#fs-card-number',title:'Card number',placeholder:'Card number'},ccexp:{selector:'#fs-card-expiry',title:'Expiration',placeholder:'MM / YY'},cvv:{selector:'#fs-card-cvv',title:'Security code',placeholder:'CVV'},
     applePay:{selector:walletOptions.wallets.applePay?'#fs-apple-pay':'#fs-no-apple-pay',
      requiredBillingContactFields:['name','postalAddress'],requiredShippingContactFields:['name','postalAddress'],
      contactFields:['phone','email'],contactFieldsMappedTo:'shipping',totalLabel:'FutureSelf RX',type:monthly?'subscribe':'buy',
      style:{height:'48px','border-radius':'32px'},isRecurringTransaction:monthly,
      ...(monthly?{recurringPaymentDescription:dollars(quote().initial_cents)+' today, then '+dollars(quote().renewal_cents)+' monthly until cancelled.',
       recurringBillingAgreement:document.getElementById('fs-express-terms').textContent,
       recurringLabel:'Monthly subscription',recurringAmount:(quote().renewal_cents/100).toFixed(2),recurringUpFrontPrice:(quote().initial_cents/100).toFixed(2),
       recurringPaymentTiming:'recurring',recurringPaymentStartDate:walletOptions.renewal_date+'T12:00:00Z',
       recurringPaymentIntervalUnit:'month',recurringPaymentIntervalCount:1,
       recurringManagementUrl:'https://checkout.futureselfrx.ai/pages/mobile-funnel#subscription-help'}:{})},
     googlePay:{selector:walletOptions.wallets.googlePay?'#fs-google-pay':'#fs-no-google-pay',
      shippingAddressRequired:true,shippingAddressParameters:{phoneNumberRequired:true,allowedCountryCodes:['US']},
      billingAddressRequired:true,billingAddressParameters:{format:'FULL',phoneNumberRequired:true},emailRequired:true,buttonType:monthly?'subscribe':'pay'}
    };

   document.getElementById('fs-wallet-buttons').hidden=false;
   window.CollectJS.configure({variant:'inline',paymentSelector:'#fs-sdk-unused',styleSniffer:false,
    customCss:{'height':'48px','line-height':'24px','padding':'12px 14px','font-size':'16px','font-family':'Arial, sans-serif','color':'#252d27','background-color':'#f3f3f7','border-style':'none','border-width':'0','border-radius':'12px','margin-top':'0','margin-bottom':'0'},
    placeholderCss:{color:'#7a817b'},focusCss:{'background-color':'#fff'},
    price:walletOptions.amount,currency:'USD',country:'US',fields:walletFields,
    callback:result=>{if(generation===paymentGeneration && configuredPlan===plan)paymentReceived(result);},
    validationCallback:(field,valid)=>{if(generation!==paymentGeneration)return;if(!valid && busy && !session){tokenizing=false;clearTimeout(tokenTimer);locked(false);message('Check your card number, expiration date, and security code.');}},
    fieldsAvailableCallback:()=>{if(generation!==paymentGeneration)return;configured=true;configuredPlan=requestedPlan;loadingFields=false;document.getElementById('fs-payment-retry').hidden=true;locked(false);message('');},
    timeoutCallback:()=>{if(generation!==paymentGeneration || session)return;configured=false;loadingFields=false;locked(false);document.getElementById('fs-nmi-submit').disabled=true;document.getElementById('fs-payment-retry').hidden=false;message('Secure fields are taking longer than expected. Retry to continue. No payment was submitted.');}
   });
  }catch(error){if(generation!==paymentGeneration)return;loadingFields=false;configured=false;syncWalletAvailability();document.getElementById('fs-payment-retry').hidden=false;message(error.message || 'Payment fields unavailable. Please retry.');}
 }
 async function paymentReceived(result) {
  if(tokenInFlight || session) return;
  if(['applePay','googlePay'].includes(result.tokenType)) {await walletReceived(result);return;}
  if(!tokenizing)return;tokenizing=false;clearTimeout(tokenTimer);
  const contact=fields();if(!contact){locked(false);return;}
  tokenInFlight=true;locked(true);
  try{
   requestId=requestId || crypto.randomUUID();
   session=await api('/sessions',{tracking:window.fsCheckoutTracking?.()||{},request_id:requestId,plan:planId(),contact,consent:true,consent_version:config.consent_version});session.plan=plan;
   sessionStorage.setItem(storageKey,JSON.stringify({session_token:session.session_token,plan}));
   document.getElementById('fs-contact-form').querySelectorAll('input').forEach(el=>{el.disabled=true;});
   document.getElementById('fs-billing-consent').disabled=true;
   document.getElementById('fs-express').hidden=true;
   await submitToken(result);
  }catch(error){if(session){message('Confirming payment. Please do not pay again.');await poll();}else{message(error.message || 'Unable to prepare checkout. Please try again.');tokenInFlight=false;locked(false);}}
 }
 async function walletReceived(result) {
  if (expressSubmitting || session || pendingWallet) return;
  if (!['applePay','googlePay'].includes(result.tokenType) || !walletOptions.wallets[result.tokenType]) {expressMessage('This wallet is unavailable. Use a card instead.');return;}
  if (!document.getElementById('fs-billing-consent').checked) {expressMessage('Please accept the payment terms and reopen your wallet.');return;}
  const wallet=result.wallet || {}, shipping=wallet.shippingInfo || {}, billing=wallet.billingInfo || {};
  if (shipping.country!=='US' || billing.country!=='US') {expressMessage('This checkout requires a U.S. shipping and billing address. No payment was submitted.');return;}
  const contact={first_name:shipping.firstName,last_name:shipping.lastName,email:wallet.email,phone:shipping.phone || billing.phone,
   address1:shipping.address1,address2:shipping.address2 || '',city:shipping.city,state:shipping.state,zip:shipping.postalCode};
  const form=document.getElementById('fs-contact-form');
  for(const [name,value] of Object.entries(contact)) form.elements[name].value=value || '';
  document.getElementById('fs-billing-consent').checked=true;
  pendingWallet=result;
  // Missing wallet contact details can be completed manually before any payment request.
  expressLocked=false;locked(false);document.getElementById('fs-express').hidden=true;
  if (!fields()) {message('Complete the missing details to finish your wallet payment. No payment has been submitted.');return;}
  await completeWallet(result);
 }
 async function completeWallet(result) {
  if (expressSubmitting) return;
  const contact=fields();if (!contact)return;
  expressSubmitting=true;locked(true);showCheckoutStep(2);
  try {
   if (!session) {
    requestId=requestId || crypto.randomUUID();
    session=await api('/sessions',{tracking:window.fsCheckoutTracking?.()||{},request_id:requestId,plan:planId(),contact,consent:true,consent_version:config.consent_version,
     payment_method:result.tokenType,renewal_date:walletOptions.renewal_date,
     billing_contact:{email:contact.email,phone:result.wallet.billingInfo.phone || contact.phone,first_name:result.wallet.billingInfo.firstName,last_name:result.wallet.billingInfo.lastName,
      address1:result.wallet.billingInfo.address1,address2:result.wallet.billingInfo.address2 || '',city:result.wallet.billingInfo.city,state:result.wallet.billingInfo.state,zip:result.wallet.billingInfo.postalCode}});session.plan=plan;
    sessionStorage.setItem(storageKey,JSON.stringify({session_token:session.session_token,plan}));
   }
   document.getElementById('fs-contact-form').querySelectorAll('input').forEach(el=>{el.disabled=true;});
   document.getElementById('fs-billing-consent').disabled=true;
   const data=await api('/charge',{session_token:session.session_token,payment_token:result.token,payment_method:result.tokenType});
   pendingWallet=null;
   if (!await showStatus(data))await poll();
  } catch(error) {
   if (session) {message('Confirming your wallet payment. Do not pay again.');await poll();}
   else {message(error.message || 'Unable to prepare your wallet payment. No payment request was submitted.');expressSubmitting=false;locked(false);}
  }
 }

 document.addEventListener('fs:funnel-state',event=>{
  if (session && session.plan !== event.detail.plan) return;
  const nextPlan=event.detail.plan || 'monthly';
  if(nextPlan!==plan){
   paymentGeneration++;configured=false;configuredPlan=null;loadingFields=false;
   walletOptions=null;requestId=null;pendingWallet=null;
   document.getElementById('fs-billing-consent').checked=false;
   document.getElementById('fs-wallet-buttons').hidden=true;
   document.getElementById('fs-nmi-submit').disabled=true;
  }
  plan=nextPlan;
  document.getElementById('fs-nmi-submit').textContent='Pay '+(quote()?dollars(quote().initial_cents):(plan==='bundle'?'$299':'$79'))+' now';
  syncWalletAvailability();
  const consent=document.getElementById('fs-billing-terms');
  if (consent && quote()) consent.textContent=billingTerms();
  document.getElementById('fs-express-terms').textContent=consent.textContent;
  if(checkoutStep===2 && event.detail.step===3)initializePayment();
 });
 const initialize=async()=>{
  const submit=document.getElementById('fs-nmi-submit');
  plan=root.querySelector('[data-action="chooseBundle"]')?.getAttribute('aria-pressed')==='true'?'bundle':'monthly';
  document.dispatchEvent(new CustomEvent('fs:funnel-state',{detail:{plan}}));
  try {config=catalog || await api('/configuration');document.dispatchEvent(new CustomEvent('fs:funnel-state',{detail:{plan}}));}catch(_){message('Checkout is temporarily unavailable.');return;}
  document.getElementById('fs-billing-consent').addEventListener('change',syncWalletAvailability);syncWalletAvailability();
  if(checkoutStep===2) initializePayment();
  document.getElementById('fs-payment-retry').addEventListener('click',()=>{configuredPlan=null;initializePayment();});
  document.getElementById('fs-wallet-buttons').addEventListener('click',event=>{
   if(busy || session || !fields()){event.preventDefault();event.stopImmediatePropagation();}
  },true);
  if (!config.enabled) {message('Checkout is being prepared. No payments are accepted yet.');return;}
  submit.disabled=!configured;
  submit.addEventListener('click',()=>{
   if(busy || session || !configured)return;
   const contact=fields();if(!contact)return;
   if(pendingWallet){completeWallet(pendingWallet);return;}
   locked(true);tokenizing=true;message('Checking card details…');
   tokenTimer=setTimeout(()=>{if(!session&&!tokenInFlight&&tokenizing){tokenizing=false;locked(false);message('Card verification timed out. Please try again. No payment was submitted.');}},20000);
   try{window.CollectJS.startPaymentRequest();}catch(_){tokenizing=false;clearTimeout(tokenTimer);locked(false);message('Unable to verify the card. Please retry.');}
  });
  document.getElementById('fs-cancel-renewals').addEventListener('click',async()=>{
   try{await api('/cancel',{session_token:session.session_token});message('Future monthly renewals have been cancelled.');document.getElementById('fs-cancel-renewals').hidden=true;}
   catch(error){message(error.message);}
  });
  try {
   const saved=JSON.parse(sessionStorage.getItem(storageKey) || 'null');
   if (saved) {session=saved;plan=saved.plan;showCheckoutStep(2,false);locked(true);await poll();}
  }catch(_){message('Unable to resume checkout. Contact support before paying again.');}
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();
})();
